type MunicipioIdInput =
  | string
  | {
      _id: string;
      nome?: string;
    };

function normalizeMunicipioIds(
  municipioIds?: MunicipioIdInput[] | null,
): string[] {
  if (!municipioIds?.length) {
    return [];
  }

  return municipioIds
    .map(municipio =>
      typeof municipio === 'string' ? municipio : municipio?._id,
    )
    .filter((municipioId): municipioId is string => !!municipioId);
}

export { normalizeMunicipioIds };
export type { MunicipioIdInput };
